<template>
  <div id="matrix-banner" class="md:container md:mx-auto md:pt-20 lg:px-12" data-component="molecule/matrix/matrix-banner">
    <div class="grid grid-cols-12">
      <article class="col-span-full 2xl:col-end-11 2xl:col-start-3 lg:col-end-13 lg:col-start-1 xl:col-end-12 xl:col-start-2">
        <div class="2xl:p16 xl:p12 rounded-xl xl:bg-white">
          <div class="grid grid-cols-12 lg:gap-x-8 lg:gap-y-10">
            <div class="col-span-full row-end-3 row-start-1 md:col-end-8 md:col-start-1 md:row-end-5">
              <figure class="banner__figure overflow-hidden md:-mt-20">
                <MoleculePicture img-class="h-full w-full relative block banner-image" :image="image" />
              </figure>
            </div>
            <div
              class="relative z-10 flex flex-col col-end-13 col-start-3 row-end-5 row-start-2 items-start self-center mt-32 p-8 rounded-l-xl md:col-span-full md:col-end-13 md:col-start-7 md:row-start-1 md:mt-0 md:rounded-xl xl:-mr-16 xl:ml-24 xl:p-12"
              :class="[backgroundColor]"
            >
              <h3 class="text-black break-word mb-4 text-base font-bold leading-tight uppercase lg:text-2xl lg:leading-none">
                {{ title }}
              </h3>

              <div class="text-black mb-6 text-base leading-tight lg:text-xl" v-html="introduction" />

              <AtomButton
                v-if="primaryButtonLabel && primaryButtonUrl"
                button-type="quinary"
                :url="primaryButtonUrl"
                class="group inline-flex"
                :class="{ 'mb-2 lg:mb-4': secondaryButtonLabel && secondaryButtonUrl }"
              >
                {{ primaryButtonLabel }}
                <AtomIconArrowRight class="ml-3 w-3 transform group-hover:translate-x-1 transition duration-200" />
              </AtomButton>

              <AtomLink v-if="secondaryButtonLabel && secondaryButtonUrl" :url="secondaryButtonUrl" :title="secondaryButtonLabel" class="group">
                <span class="text-black border-b-2 border-black">{{ secondaryButtonLabel }}</span>
                <AtomIconArrowRight class="inline-flex ml-3 w-3 transform group-hover:translate-x-1 transition duration-200" />
              </AtomLink>
              <!--              </div>-->
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string
  subtitle?: string | null
  introduction: string
  image: Record<string, any>
  primaryButtonLabel?: string
  primaryButtonUrl?: string
  secondaryButtonLabel?: string
  secondaryButtonUrl?: string
  backgroundColor?: string
}

withDefaults(defineProps<Props>(), {
  subtitle: null,
  primaryButtonLabel: undefined,
  primaryButtonUrl: undefined,
  secondaryButtonLabel: undefined,
  secondaryButtonUrl: undefined,
  backgroundColor: 'bg-app-lime',
})
</script>

<style lang="scss" scoped>
.banner-image {
  margin-left: -10vw;

  @screen sm {
    margin-left: 0;
  }
}
</style>
